import ENDPOINTS from '../../const/endpoints';
export const debtCancellationCacheKey = ({ accountId, accountIdType, interstitialSkipDate }) => [
    `GET-${ENDPOINTS.debtCancellation}`,
    { accountId, accountIdType, interstitialSkipDate }
];
